import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { Popup } from "react-leaflet";
import getDates from "../../../shared/services/date.service";

const valueOfSensor = (value) => {
  return value ? " включен;" : " выключен;";
};

class WinterMaintenceMapPoup extends Component {
  render() {
    const { data, unit } = this.props;

    return (
      <Popup className="mapPopup" closeButton={false}>
        <div className="mapPopupContent">
          <div className="contentItem">
            <span className="title">Область</span>
            <span className="data">{unit.areaTitle}</span>
          </div>

          <div className="contentItem">
            <span className="title">Организация</span>
            <span className="data">{unit.parentCompanyTitle}</span>
          </div>

          <div className="contentItem">
            <span className="title">Филиал</span>
            <span className="data">{unit.companyTitle}</span>
          </div>

          <div className="contentItem">
            <span className="title">ТС</span>
            <span className="data">{unit.title}</span>
          </div>

          <div className="contentItem">
            <span className="title">Гос номер</span>
            <span className="">
              <b>
                <a href={`/cars/${unit.id}/intimerange`} target="_blank" rel="noreferrer">{unit.registerNumber}</a>
              </b>
            </span>
          </div>

          <div className="contentItem">
            <span className="title">Время</span>
            <span className="data">{`${getDates.getDateFormat3(data["TI"])}`}</span>
          </div>

          <div className="contentItem">
            <span className="title">Скорость</span>
            <span className="data">{data["SPEE"]}</span>
          </div>

          {unit.isDumpSensor || unit.isSandSendor ? (
            <div className="contentItem">
              <span className="title">Оборудование</span>
              <span className="data">
                <div>
                  {unit.isDumpSensor ? <div>Датчик отвала: {valueOfSensor(data["DU1"])}</div> : null}
                  {unit.isSandSensor ? <div>Датчик посыпки: {valueOfSensor(data["SAND"])}</div> : null}
                </div>
              </span>
            </div>
          ) : null}

          <div className="contentItem">
            <span className="title">Группы</span>
            <span className="data">
              <div>
                {unit.groups.length === 0
                  ? "Вне групп"
                  : unit.groups.map((x) => {
                      return <div key={x.id}>{x.title}</div>;
                    })}
              </div>
            </span>
          </div>
        </div>
      </Popup>
    );
  }
}

export default React.memo(WinterMaintenceMapPoup);
